module.exports = __webpack_public_path__ + "static/media/footerLogo.3a7bcda9.svg";